__turbopack_context__.v({
  "actions": "NotificationDrawerHeader-module-scss-module__xSIqtq__actions",
  "header": "NotificationDrawerHeader-module-scss-module__xSIqtq__header",
  "title": "NotificationDrawerHeader-module-scss-module__xSIqtq__title",
});
